export const API_path = {
  login: "/api/user/login",
  logout: "/api/user/logout",
  getUserOption: "/api/userOptions/getUserOptionByUserId",
  getAllCustomers:"/api/customer",
  getAllMedicine:"/api/medicine/getAllMedicineByBranchId",
  createOrder:"/api/inventory/createOrder",
  getOrders:"/api/inventory/getOrders",
  getStockDetails:"/api/inventory/getStockDetails",
  getOrdersReport:"/api/dashboard/getOrdersReport"
};
